/**
 * Route for `regional-support`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RegionalSupportPage } from "../features/regional-support/RegionalSupportPage";

export const regionalSupportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/regional-support",
	component: RegionalSupportPage,
});

export default regionalSupportRoute;
